<template>
    <div class="tab-view">
        <el-tabs v-model="selectTab" type="card" closable @tab-click="jumpTo" @tab-remove="closeTabItem" class="abcd">
            <el-tab-pane
                    v-for="(item,index) in tabViews"
                    :key="item.path"
                    :label="item.name"
                    :name="item.path">
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    export default{
        data(){
            return {
                selectTab:'/'+this.$route.path.split('/')[1]
            }
        },
        watch:{
            $route(){
                console.log(this.$route)
                this.selectTab = '/'+this.$route.path.split('/')[1]
            }
        },
        computed:{
            tabViews(){
                return this.$store.state.tabView.tabViewDatas
            }
        },
        mounted(){
//            console.log(this.$route)
        },
        methods:{
            jumpTo(tag){
                this.$router.push(tag.name)
            },
            closeTabItem(tag){
                let tabLength = this.tabViews.length;
                let _this = this;
                this.tabViews.forEach(function(item,index){
                    if(item.path == tag){
                        if(tag == _this.selectTab&&tabLength>1){
                            let nextIndex = index == tabLength-1?index-1:index+1;
                            _this.selectTab = _this.tabViews[nextIndex].path;
                            _this.$router.push(_this.tabViews[nextIndex].path)
                        }
                        _this.tabViews.splice(index,1)
                        _this.$store.commit('CLOSE_TAB_VIEW_ITEM',_this.tabViews)
                    }
                })

            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .tab-view{
        padding: 8px 0 8px 10px;
        border-bottom: #3b4761;
        box-shadow: 0 1px 3px 0 rgba(0,0,0,0.12), 0 0 3px 0 rgba(0,0,0,0.04);
        .el-tag{
            margin-right: 8px;
        }
        .el-tabs--card>.el-tabs__header .el-tabs__item .el-icon-close{
            width: 14px;
        }
        .el-tabs__item {
            padding: 0 10px;
            height: 30px;
            line-height: 30px;
            list-style: none;
            font-size: 12px;
            font-weight: normal;
            color: #606266;
            background: #ffffff;
            margin: 0 5px;
            border-radius: 3px;
        }
        .el-tabs__item:first-child .el-icon-close{
            display: none;
        }
        .el-tabs__item.is-active{
            background: #41B883;
            color:#ffffff;
        }
        .el-tabs__item .el-icon-close{
            -webkit-transition: none;
            -o-transition: none;
            transition: none;
        }
        .el-tabs__nav-next, .el-tabs__nav-prev{
            line-height: 34px;
        }
        .el-tabs__header{
            margin: 0;
        }
        .el-tabs--card>.el-tabs__header{
            border-bottom: none;
        }
        .el-tabs--top.el-tabs--card .el-tabs__item:nth-child(2){
            padding: 0 10px;
        }
        .el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover {
            padding-left: 20px;
            padding-right: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/tabView.vue